import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AbilityAction,
  AbilitySubject,
} from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';
import { AbilityService } from '../services/ability.service';
import { CanGuardOptions } from './can.guard';

export const canSomeGuard = (
  checks: Map<AbilitySubject, AbilityAction>,
  options?: CanGuardOptions,
): CanActivateFn => {
  return (route, state) => {
    const abilityService = inject(AbilityService);
    const router = inject(Router);

    return abilityService.ability$.pipe(
      map((ability) => {
        for (const [subject, action] of checks.entries()) {
          if (ability.can(action, subject)) {
            return true;
          }
        }

        return router.createUrlTree(
          options?.returnTo || ['/forbidden'],
          options?.returnToExtras,
        );
      }),
    );
  };
};
